/* eslint-disable no-return-assign */
import React, { FC } from 'react';
import { Box, TextField, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import {InitialFilterRangeValue} from "../../modules/common/PortfolioManager/types";

type FieldRangeProps = {
  onChange: (newValues: FieldRange) => void;
  values: FieldRange | ValueType[];
  label: string;
  rangeLimit: InitialFilterRangeValue
};

type FieldRange = {
  fromRange?: ValueType;
  toRange?: ValueType;
};

type ValueType = string | number | null;

const useStyles = makeStyles(() => ({
  inputField: {
    width: '48%',
  },
}));

export const FieldRange: FC<FieldRangeProps> = ({ onChange, values, label, rangeLimit }) => {
  const classes = useStyles();
  const { minimum: min, maximum: max } = rangeLimit

  const fieldProps = {
    inputProps: {
      max, min
    }
  }

  const initialValueParser = (data: any) => {
    if (data.fromRange !== null && data.fromRange !== undefined) {
      const { fromRange, toRange } = values as FieldRange;
      if (fromRange !== undefined && toRange !== undefined) {
        return [fromRange, toRange];
      }
    }
    return data as (string | number)[];
  };

  const [value1, value2] = initialValueParser(values);

  const validateOnChange = (initialValue, variant) => {
    let value = Number(initialValue)
    if (min === null || max === null || value1 === null || value2 === null) return value
    if (variant === 'min') {
      if (value > value2) value = value2 as number;
      if (value < min) value = min;
    }
    if (variant === 'max') {
      if (value > max) value = max;
      if (value < value1) value = value1 as number;
    }
    return value
  }

  return (
    <>
      <Typography>{label}</Typography>
      <Box display="flex" alignItems="center" width="100%" justifyContent="space-between" pb={3}>
        <TextField
          className={classes.inputField}
          value={value1}
          type='number'
          InputProps={fieldProps}
          onChange={e => onChange({ fromRange: validateOnChange(e.target.value, 'min'), toRange: value2 })}
        />
        -
        <TextField
          className={classes.inputField}
          value={value2}
          type='number'
          InputProps={fieldProps}
          onChange={e => onChange({ fromRange: value1, toRange: validateOnChange(e.target.value, 'max') })}
        />
      </Box>
    </>
  );
};
